// Hook personalizado para manejar errores de API automáticamente
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const useApiErrorHandler = () => {
  const navigate = useNavigate();
  const { handleUnauthorized, updateUser } = useAuth();

  useEffect(() => {
    // Temporalmente deshabilitado el interceptor global para evitar conflictos
    // El manejo de errores 401 se hace directamente en ApiService
  }, [handleUnauthorized]);

  // Función auxiliar para manejar errores en componentes
  const handleApiError = (error) => {
    console.error('🔥 Error de API manejado por hook:', error);
    
    if (error.message.includes('401') || 
        error.message.includes('Unauthorized') || 
        error.message.includes('Sesión expirada')) {
      
      console.warn('🔐 Error 401 detectado en componente - Ejecutando logout automático');
      handleUnauthorized();
      return;
    }

    if (
      error?.requirePasswordChange ||
      error?.data?.requirePasswordChange ||
      error?.data?.RequirePasswordChange ||
      String(error?.message || '').toLowerCase().includes('debe cambiar su contraseña')
    ) {
      updateUser({ requirePasswordChange: true });
      navigate('/cambiar-contrasena', { replace: true });
      return;
    }
    
    // Para otros errores, permitir que el componente los maneje
    throw error;
  };

  return {
    handleApiError
  };
};

export default useApiErrorHandler;
